export default {
  "tinyMCE.insertTable": {
    en: "Insert table",
    es: "Insertar tabla",
  },
  "tinyMCE.placeholders": {
    en: "Placeholders",
    es: "Variables",
  },
  "tinyMCE.video": {
    en: "Video",
    es: "Vídeo",
  },
  "tinyMCE.lineBreak": {
    en: "Line break",
    es: "Salto de línea",
  },
  "tinyMCE.image": {
    en: "Image",
    es: "Imagen",
  },
  "tinyMCE.sameWindow": {
    en: "Same window",
    es: "Misma ventana",
  },
  "tinyMCE.newWindow": {
    en: "New window",
    es: "Nueva ventana",
  },
};
